import { useState, useEffect } from "react";
import axios from "axios";

export default function Crypto({ espont }) {
  const [crypto, setCrypto] = useState({ BTC: null, ETH: null, SHFL: null });

  useEffect(() => {
    const fetchCryptoData = async () => {
      try {
        const response = await axios.get(
          "https://api.coingecko.com/api/v3/coins/markets",
          {
            params: {
              vs_currency: "usd",
              ids: "bitcoin,ethereum,shuffle-2",
            },
          },
        );
        let btc =
          "$" +
          Math.floor(response.data[0].current_price).toLocaleString("en-US", {
            maximumFractionDigits: 0,
            useGrouping: true,
          });
        let eth =
          "$" +
          Math.floor(response.data[1].current_price).toLocaleString("en-US", {
            maximumFractionDigits: 0,
            useGrouping: true,
          });
        let shfl = "$" + parseFloat(response.data[2].current_price).toFixed(4);
        setCrypto([btc, eth, shfl]);
      } catch (error) {
        console.error("Error fetching crypto data:", error);
      }
    };

    fetchCryptoData();
    const interval = setInterval(fetchCryptoData, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="valutak">
      <p className="crypto">
        <img src="./btc.png" alt="BTC" width="25px" /> {crypto[0]}
      </p>
      <p className="crypto">
        <img src="./eth.png" alt="ETH" width="25px" /> {crypto[1]}
      </p>
      <p className="crypto">
        <img src="./shuffle.png" alt="SHFL" width="25px" /> {crypto[2]}
      </p>
      <p className="flex items-start justify-center flex-row gap-2">
        <div className="flex flex-row justify-center items-center gap-1">
          <img src="./sima.png" alt="Espont" width="20px" />
          <span>{espont.sima} simple</span>
        </div>
        <div className="flex flex-row justify-center items-center gap-1">
          <img src="./dupla.png" alt="Espont" width="20px" />
          <span>{espont.dupla} double</span>
        </div>
      </p>
    </div>
  );
}
